import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { styles } from './Icon.scss';

const cx = classNames.bind(styles);

const svgIcons = require.context('@digsup/assets-icons/src', false, /\.svg$/);
const iconsMap = svgIcons.keys().reduce((icons, iconName) => {
  const svgAssetsPath = iconName.replace('./', '');
  // eslint-disable-next-line import/no-dynamic-require, global-require
  const spriteSvg = require(`@digsup/assets-icons/src/${svgAssetsPath}?sprite`);
  return {
    [svgAssetsPath]: spriteSvg.default,
    ...icons,
  };
}, {});

const IconComponent = ({
  name,
  size,
  fill,
  shapeColor,
  shape,
  label,
  className,
  forwarderRef,
  ...props
}) => {
  const ariaLabel = label || `icon: ${name}`;

  const iconClasses = cx(
    'c-icon',
    {
      [`c-icon--${name}`]: name,
      [`c-icon--size-${size}`]: size,
      [`c-icon--shape-${shape}`]: shape,
      [`u-color-${fill}`]: fill,
      [`u-background-${shapeColor}`]: shapeColor,
    },
    className,
  );
  const svgClasses = cx('c-icon__icon');

  const icon = iconsMap[`${name}.svg`];
  return (
    <span className={iconClasses} ref={forwarderRef} aria-label={ariaLabel}>
      <svg viewBox={icon?.viewBox} className={svgClasses} {...props}>
        <use xlinkHref={`#${icon?.id}`} />
      </svg>
    </span>
  );
};

export const Icon = React.forwardRef((props, ref) => (
  <IconComponent {...props} forwarderRef={ref} />
));

export const sizes = ['auto', 'small', 'medium', 'large', 'xlarge', 'xxlarge'];

export const shapes = ['square', 'round', 'none'];

Icon.displayName = 'Icon';

Icon.propTypes = {
  /**
   * Name of DigsUp icon
   */
  name: PropTypes.string.isRequired,
  /**
   * Control the size of the icon
   */
  size: PropTypes.oneOf(sizes),
  /**
   * Define the color used to paint the svg element
   */
  fill: PropTypes.string,
  /**
   * Define the background color for icon component
   */
  shapeColor: PropTypes.string,
  /**
   * Define the shape for icon component
   */
  shape: PropTypes.oneOf(shapes),
  /**
   * String to use as the aria-label for the icon.
   */
  label: PropTypes.string,
  /**
   * Extend the classNames applied to the component
   */
  className: PropTypes.string,
};

Icon.defaultProps = {
  name: 'arrow-simple-right',
  size: 'auto',
  shape: 'none',
  className: '',
};
